/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum];


